<template>
  <div class="content if-profile manual_input report-tab">
    <div class="md-layout ratios-report">
      <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100 header m-0">
        <VRHeader :headerData="this.headerData"/>
      </div>
      <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100 p-0">
        <div class="manege-input-popap">
          <!--          <md-dialog :md-active.sync="showDialog">-->
          <!--            <p><b>Net Working Capital (Current Assets-Current Liabilities)/Business Revenue.</b>-->
          <!--              Indicates if a company is maintaining a reasonable level of liquidity relative to its Business Revenue-->
          <!--              volume.-->
          <!--              Higher is generally better, but very high ratios may indicate an overly conservative reliance on liquid-->
          <!--              assets,-->
          <!--              while low ratios suggest the opposite. Your score suggests that the business should undertake a-->
          <!--              significant review of liquidity practices.-->
          <!--            </p>-->
          <!--          </md-dialog>-->
          <!--          <md-card-header class="md-card-header-icon messages-box">-->
          <!--            <div class="card-icon md-ripple" @click="showDialog = true">-->
          <!--              <md-icon class="icon-arrow">double_arrow</md-icon>-->
          <!--              <md-icon>help</md-icon>-->
          <!--            </div>-->
          <!--          </md-card-header>-->
        </div>
        <div class="md-toolbar-row">
          <nav-tabs-card>
            <template slot="content">
              <h1 v-if="!isSample" class="section_header m-0 p-0">
                Manage Inputs </h1>
              <!-- <md-card-header class="md-card-header-icon manag-title">
                <h1 class="md-headline text-left">
                  Manage Inputs
                </h1>
              </md-card-header>-->
              <div class="md-layout">
                <div v-if="!isSample" class="md-layout-item md-size-100 p-0">
                  <md-card class="if_card">
                    <md-card-header class="md-card-header-icon">Data Input Upload
                    </md-card-header>
                    <md-card-content>
                      <div class="extra_space">
                        <div class="md-layout">
                          <div class="md-layout-item md-medium-size-100 md-size-100 p-0">
                            <!-- <h3>Data Input Upload</h3> -->
                            <ul>
                              <li>
                                Download the Bizminer Industry Financial Input 5-year Templateand save it offline as a CSV file.
                              </li>
                              <li>Populate the template offline</li>
                              <li>
                                Select the Choose File or Browse button to find the populated CSV file on your device.
                              </li>
                              <li>
                                Use the Upload Inputs button to complete the process.
                              </li>
                              <li>
                                Generate the report. Your financials will be integrated; percentages, summary line items and ratios will auto-calculate.
                              </li>
                            </ul>
                          </div>
                        </div>
                        <div class="md-layout">
                          <div class="md-layout-item p-0">
                            <upload-my-data></upload-my-data>
                          </div>
                        </div>
                      </div>
                    </md-card-content>
                  </md-card>
                </div>
                <div class="md-layout-item md-medium-size-100 md-size-100 md-large-size-100 py-4">
                  <h1 class="section_header p-0 my-2">Manual Input</h1>
                  <h5 class="m-0">
                    <strong> *Please do not use periods, dollar signs, or character, Commas are auromatically added. </strong>
                  </h5>
                  <h5 class="m-0">
                    <strong> *Business Revenue and Gross Margin are required fields </strong>
                  </h5>
                </div>
                <div class="md-layout-item md-medium-size-100 md-size-100 md-large-size-100 p-0 mt-2">
                  <md-tabs md-alignment="left">
                    <md-tab v-for="input in inputFields" :id="input.title" :key="input.title" :md-label="input.title" md-icon="arrow_drop_down" class="p-0">
                      <div class="md-layout">
                        <div class="md-layout-item p-0">
                          <md-card-header>{{ input.title }}</md-card-header>
                          <md-card-content>
                            <md-table class="profit-and-loss-table">
                              <md-table-row>
                                <md-table-head :class="{
                                    'md-table-black-side-label':
                                      input.type !== 'BlueYears',
                                    'md-table-side-label':
                                      input.type === 'BlueYears',
                                  }">{{ input.title }}
                                </md-table-head>
                                <md-table-head v-for="key in years" :key="key" class="md-table-side-label">{{
                                    input.type === "BlueYears" ? key : ""
                                  }}
                                </md-table-head>
                              </md-table-row>
                              <md-table-row v-for="field in input.data" :key="field">
                                <md-table-cell :md-label="input.title">
                                  {{ (['revenue', 'officers_compensation', 'pre_tax_net_profit', 'income_expense_addbacks'].some(data => data === field) ? '*' : '') }}
                                  {{ inputStructure[field]["label"] }}
                                </md-table-cell>

                                <md-table-cell v-for="(val, index) in currentData.length ? currentData : years" :key="index">
                                  <input class="vpro_input_field" v-if="currentData.length" :id="field + '_' + index" v-model="val[field]" @input="(e) => handleInput(e, field, index) "/>
                                  <input class="vpro_input_field" v-if="!currentData.length" :id="field + '_' + index" @input="(e) => handleInput(e, field, index)" />
                                </md-table-cell>

                              </md-table-row>
                            </md-table>
                          </md-card-content>
                        </div>
                      </div>
                      <div v-if="!isSample" class="md-layout-item md-size-100 p-0 btn_wpr">
                        <button type="button" class="md-button md-raised md-info md-theme-default button-inputs" @click="saveReport('clear')">
                          <div class="md-ripple">
                            <div class="md-button-content">Clear Inputs</div>
                          </div>
                        </button>
                        <button type="button" class="md-button md-raised md-info md-theme-default" @click="saveReport()">
                          <div class="md-ripple">
                            <div class="md-button-content">
                              Submit Manual Inputs
                            </div>
                          </div>
                        </button>
                      </div>
                    </md-tab>
                  </md-tabs>
                </div>
              </div>
            </template>
          </nav-tabs-card>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import VRHeader from "./_partials/VRHeader";
import {NavTabsCard} from "@/components";
import {mapActions, mapState} from "vuex";
import UploadMyData from "@/components/UploadMyData.vue";

export default {
  components: {
    NavTabsCard,
    VRHeader,
    UploadMyData,
  },
  props: ["headerData"],
  data() {
    return {
      view: "dollar",
      showDialog: false,
      params: {},
      single: null,
      inputData: [],
      currentData: [],
    };
  },
  mounted() {
    let section = this.$route.query.section;
    if (!section) {
      section = "cash-flow-solvency";
    }
    this.switchView(section);



    if(this.vestimateReport.input_structure) {
      let IFInputs = this.vestimateReport.input_structure["IFInputs"]; // TODO: (RAY) TOOK THIS OUT! Look into fixing this permanently.
      this.years.forEach((elem, index) => {
        let a = {};
        a.year = elem;
        this.inputFields.forEach((info, i) => {
          info.data.forEach((element, index) => {
            if (IFInputs[elem] && element in IFInputs[elem]) {
              a[element] = {};
              a[element].name = IFInputs[elem][element].field;
              a[element].value = IFInputs[elem][element].value;
              a[element].input = element;
            }
          });
        });
        this.inputData.push(a);
      });
      this.years.forEach((elem, index) => {
        let b = {};
        b.year = parseInt(this.years[index]) + 1;
        this.inputFields.forEach((info, i) => {
          info.data.forEach((element, index) => {
            if (IFInputs[elem] && element in IFInputs[elem]) {
              b[element] = IFInputs[elem][element]["value"];
            }
          });
        });
        this.currentData.push(b);
      });
    }


  },
  computed: {
    ...mapState({
      user: (state) => state.user.user,
      client: (state) => state.user.vestimate_report.data.developerClient,
      vestimateReport: (state) => state.user.vestimate_report.data,
      naics: (state) => state.user.vestimate_report.data.IMRnaics,
      industryName: (state) => state.user.vestimate_report.data.IMRindustry,
      reportDate: (state) => state.user.vestimate_report.data.report_date,
      /*displayArea: (state) => state.user.vestimate_report.data.MR.area, // TODO: (RAY) TOOK THIS OUT! Look into fixing this permanently.
      companyName: (state) => state.user.vestimate_report.data.input_structure["Company Name"]["value"],*/
      inputFields: (state) => state.user.vestimate_report.data.inputFields,
      inputStructure: (state) =>
          state.user.vestimate_report.data.inputStructure,
      showYears: (state) => state.user.vestimate_report.data.showYears,
      yearsAux: (state) => state.user.vestimate_report.data.years,
    }),
    years() {
      return this.yearsAux.map((item) => {
        if (!this.$route.path.includes("dev")) return item;
        return item - 1;
      });
    },
    isSample() {
      return this.$route.path.indexOf("sample") > -1;
    },
  },
  watch: {
    "$route.query.section"() {
      let section = this.$route.query.section;
      if (!section) {
        section = "cash-flow-solvency";
      }
      this.switchView(section);
    },
  },
  methods: {
    ...mapActions({
      save: "user/saveVestimateReport",
      getVestimateReport: "user/getVestimateReport",
      alertSuccess: "alerts/success",
      alertError: "alerts/error",
      updatePullTime: "tracking/updatePullTime",
    }),
    switchView: function (type) {
      this.view = type;
    },
    handleInput(e, key, index) {
      this.params[key + index] = Number(e.target.value);
    },
    saveReport(action = "save") {
      this.loading = true;
      let params = {};
      if (action === "save") {

        /*let currentData = this.currentData.reduce(
            (acc, item, index) => ({
              ...acc,
              ...Object.entries(item).reduce(
                  (acc, [key, val]) => ({
                    ...acc,
                    [key + index]: val,
                  }),
                  {}
              ),
            }),
            {}
        );*/

        const inputElements = document.getElementsByClassName("vpro_input_field");
        let dataBeingSaved = [];

        for(let i = 0; i < inputElements.length; ++i) {
          if(inputElements[i].value == "" || inputElements[i].value == 0) { continue; }
          let id = inputElements[i].id;
          id = id.replaceAll("_0", "0");
          id = id.replaceAll("_1", "1");
          id = id.replaceAll("_2", "2");
          dataBeingSaved[id] = inputElements[i].value;
        }

        let checkedYears = this.showYears.reduce((acc, v, i) => {
          if (v) return {...acc, [`year_${i}_check`]: Boolean(v)};
          else return {...acc};
        }, {});
        let checkBoxData = {
          accounts_payable_business_revenue_check: true,
          ebitda_business_revenue_check: true,
          current_ratio_check: true,
          return_on_assets_check: true,
          quick_ratio_check: true,
          return_on_net_worth_check: true,
          days_payable_check: true,
          return_on_business_revenue_check: true,
          current_liabilities_inventory_check: true,
          discretionary_owner_earnings_check: true,
          net_working_capital_check: true,
          return_on_assets_after_tax_check: true,
          cosPayables_check: true,
          return_on_net_worth_after_tax_check: true,
          cosInventory_check: true,
          return_on_business_revenue_after_tax_check: true,
          profit_employee_check: true,
          owner_earnings_employee_check: true,
          assets_business_revenue_check: true,
          interest_coverage_check: true,
          days_inventory_check: true,
          current_liabilities_net_worth_check: true,
          days_receivables_check: true,
          long_term_liabilities_net_worth_check: true,
          current_asset_turnover_check: true,
          loans_notes_payable_net_worth_check: true,
          fixed_asset_turnover_check: true,
          zscore_check: true,
          gross_margin_business_revenue_check: true,
          total_liabilities_net_worth_check: true,
          sales_per_employee_check: true,
          fixedAssetsNetWorth_check: true,
          invTurnover_check: true,
          arTurnover_check: true,
          totalAssetTurnover_check: true,
          workingCapitalTurnover_check: true,
          daysWorkingCapital_check: true,
          cashTurnover_check: true,
          efficiency_index_check: true,
          year_0_check: true,
          year_1_check: true,
          year_2_check: true,
          year_3_check: true,
          year_4_check: true,
          year_5_check: true,
          pl_balance_percent_check: true,
          pl_balance_dollar_check: true,
          source_uses_check: true,
          ratio_scores_check: true,
          summary_scores_check: true,
          saving_years: this.years,
        };
        params = {
          //...currentData,
          ...checkedYears,
          ...this.params,
          ...checkBoxData,
          ...dataBeingSaved,
        };
      }
      this.save({
        report_id: this.$route.params.id,
        profile_id: this.$route.params.id,
        type: "valuation_main",
        action: action,
        ...params,
      })
          .then((res) => {
            this.alertSuccess("Inputs successfully saved!");
            this.$router.push({
              name: "VRAbouttheData",
              params: this.$route.params.id,
            });
            this.$router.go();
          })
          .catch((err) => {
            this.alertError("An error occurred. We have been notified.");
          })
          .finally(() => {
            this.loading = false;
            this.updatePullTime({
              isFinishedDate: true,
              productId: this.$route.params.id,
            });
          });
    },
  },
};
</script>
<style lang="scss">
.ratios-report {
  .financal-report-col-1 {
    display: flex;
    align-items: center;
  }

  .financal-report-col-2 {
    .access-button {
      margin-top: 18px !important;
    }

    .financal-report-col-3 {
      display: flex;
      justify-content: flex-end;
    }
  }

  .heder-titel-col-2 {
    margin-bottom: 35px;
  }

  .summary-scores-box-star {
    .md-button-content {
      .md-icon {
        color: #3b7ef1;
      }
    }

    h4 {
      margin-left: 60px;
    }
  }

  .summary-scores-box-flag {
    .md-icon {
      color: #3b7ef1;
    }

    .w-100 {
      width: 100%;
    }
  }

  .choose-files-box {
    display: flex;
    align-items: center;
    margin-bottom: 25px;

    p {
      margin: 0 0 0 10px;
    }

    .md-icon {
      display: none !important;
    }

    .choose-file {
      background-color: #e3e4e5;
      width: 120px;
      border-radius: 3px;
      padding: 0;
      margin: 0;

      label {
        margin-right: 11px;
        position: absolute;
        left: 24px;
        top: 11px;
      }

      input {
        margin: 0;
      }
    }

    .upload-file {
      background-color: #3b7ef1;

      label {
        color: white;
        top: 11px;
      }
    }

    .md-field:not(.md-disabled):after {
      background-color: transparent;
    }
  }

  .icon-arrow {
    transform: rotate(180deg) !important;
  }

  .md-table-cell {
    // width: 100%;

    .md-table-cell-container {
      input {
        background-color: transparent !important;
        border: 1px solid #ddd;
        width: 60px;
      }
    }
  }

  .md-collapse-content {
    padding: 0 !important;
  }

  .md-collapse-title {
    font-size: 18px;
    font-weight: 500;
    letter-spacing: 0.005em;
    line-height: 16px;
  }

  .manag-title {
    h1 {
      margin: 0;
    }
  }

  .manege-input-popap {
    display: flex;
    justify-content: flex-end;
  }
}

.button-inputs {
  margin-right: 10px !important;
}

.main_tab {
  .md-theme-default {
    background-color: #eeeeee;
  }

  .md-tabs-navigation {
    display: none;
  }
}

.md-file {
  input.md-input {
    margin-left: 135px !important;
  }
}
</style>
